// 승객 세션 복원 실패 판정 (2026-10-29 CS «갑자기 왜 로그아웃이 됐나요?» — 동영(공통) 한민희)
//
// 예전엔 `passengerResume` 이 **어떤 이유로든** 실패하면 기기의 로그인 정보를 지웠다. 그래서
// 버스 안·터널에서 앱을 열거나(통신 끊김) 배포 직후 자동 새로고침 순간 연결이 불안정하면
// 서버는 멀쩡히 세션을 갖고 있는데도 **영구 로그아웃**이 됐고, 비밀번호를 잊은 승객은 그날 못 탔다.
// 이제 지우는 건 **서버가 명확히 거부한 경우**뿐이다. 나머지(통신·시간초과·서버 내부 오류)는
// 로그인 정보를 남기고 다시 시도한다.
//
// 🔴 거부 목록을 넓히지 말 것 — 특히 `internal` 을 넣으면 안 된다. 브라우저 SDK 는 **fetch 실패
//    (오프라인)를 `functions/internal` 로** 돌려준다. 넣는 순간 이 결함이 그대로 돌아온다.
// 🔴 서버(`functions/index.js` passengerResume·passengerMigrate·loadActivePassenger)가 거부에 쓰는
//    코드 = unauthenticated(승계표 없음) · invalid-argument · permission-denied(명부 없음·비활성)
//    · failed-precondition(레거시 승계 만료). 서버에 새 거부 코드를 넣으면 여기도 같이.
//
// 이 모듈은 **순수**(Firebase·React import 0) — 격리 테스트가 그대로 태운다.

const DEFINITIVE = ["unauthenticated", "invalid-argument", "permission-denied", "failed-precondition", "not-found"];

// 자동 재시도 간격(ms) — 첫 시도 실패 뒤 이만큼 기다렸다 다시. 합계 ~10초(로딩 화면 유지 시간).
export const RESUME_RETRY_MS = [1500, 3000, 5000];

/**
 * 서버가 «이 로그인 정보는 더 못 쓴다»고 답한 실패인가. true 면 기기에서 지우고 로그인 화면으로.
 * false(통신·일시 장애·알 수 없음)면 기기 정보를 **남긴다**.
 * @param {unknown} err  httpsCallable 이 던진 FirebaseError(code `functions/<code>`) 또는 무엇이든
 */
export function isDefinitiveResumeRejection(err) {
  const code = err && typeof err.code === "string" ? err.code : "";
  const bare = code.replace(/^functions\//, "");
  return DEFINITIVE.includes(bare);
}
